import { render } from "./ButtonClose.vue?vue&type=template&id=8d0f5e8c&scoped=true"
const script = {}

import "./ButtonClose.vue?vue&type=style&index=0&id=8d0f5e8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0f5e8c"]])

export default __exports__